import "core-js/modules/es.date.to-string.js";
import { differenceInYears, parse as dateParser } from 'date-fns';
import nb from 'date-fns/locale/nb/index';
import { FEMALE_NATIONAL_ID, MALE_NATIONAL_ID, INVALID, VALID } from './constants';
import { NON_DIGITS_REGEX } from '../regex';
var NATIONAL_ID_REGEX = /^(3[01]|[0-2][0-9]|[4-7][0-9])(1[0-2]|0[0-9])[0-9]{2}[0-9]{5}$/;
var getNationalIdChecksum = function getNationalIdChecksum(sanitizedNationalId) {
  var nationalId = sanitizedNationalId.substring(0, 9);
  var round1 = [3, 7, 6, 1, 8, 9, 4, 5, 2];
  var round2 = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  var getControlDigit = function getControlDigit(id, round) {
    var sum = 0;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var i in id) {
      sum += +id[i] * round[i];
    }
    return (11 - sum % 11) % 11;
  };
  var control = getControlDigit(nationalId, round1).toString();
  control += getControlDigit(nationalId + control, round2);
  return control;
};
var parse = function parse(nationalId) {
  var result = {
    lastDigits: '',
    birthDate: null,
    isDNumber: false,
    gender: null,
    age: null,
    valid: INVALID,
    nationalId: null,
    error: {
      type: 'genericError',
      message: "Invalid national Id: ".concat(nationalId)
    }
  };
  if (!nationalId || !String(nationalId || '').trim()) {
    result.error.type = 'length';
    result.error.message = 'Empty invalid national Id';
    return result;
  }
  var nationalID = nationalId.trim();
  if (nationalID.length !== 11) {
    result.error.type = 'length';
    result.error.message = "Invalid national Id length: ".concat(nationalId);
    return result;
  }
  var sanitized = nationalID.replace(NON_DIGITS_REGEX, '');
  if (!NATIONAL_ID_REGEX.test(sanitized)) {
    return result;
  }
  var checksum = getNationalIdChecksum(sanitized);
  if (checksum !== sanitized.substr(-2)) {
    return result;
  }
  var epoch = new Date(0);
  var now = new Date();
  var day = sanitized.substring(0, 2);
  var month = sanitized.substring(2, 4);
  var year = sanitized.substring(4, 6);
  var lastDigits = sanitized.substring(6, 11);
  var genderDigit = Number.parseInt(lastDigits.charAt(2), 10);
  var firstDigit = Number.parseInt(sanitized.charAt(0), 10);
  var centuryNumber = Number.parseInt(lastDigits.substring(0, 3), 10);
  if (firstDigit > 3) {
    result.isDNumber = true;
    day = "".concat(day.charAt(0) - 4).concat(day.charAt(1));
  }
  var century = centuryNumber >= 500 && centuryNumber <= 999 && Number.parseInt(year, 10) < 40 ? '20' : '19';
  var birthday = day + month + century + year;
  var birthDate = dateParser(birthday, 'ddMMyyyy', epoch, {
    locale: nb
  });
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(birthDate)) {
    return result;
  }
  result.lastDigits = lastDigits;
  result.birthDate = birthDate.toISOString();
  result.gender = genderDigit % 2 === 0 ? FEMALE_NATIONAL_ID : MALE_NATIONAL_ID;
  result.age = differenceInYears(now, birthDate);
  result.valid = VALID;
  result.nationalId = sanitized;
  result.error.type = null;
  result.error.message = null;
  return result;
};
export default parse;